import { Link } from 'react-router-dom';
import { articles } from '@/mocks/mogu-data';

export default function LatestArticles() {
  const latestArticles = articles.slice(0, 3);

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              <i className="ri-article-line text-primary-500 mr-2"></i>最新资讯
            </h2>
            <p className="mt-2 text-sm text-foreground-600">蘑菇tv最新动态与行业资讯</p>
          </div>
          <Link
            to="/articles"
            className="hidden sm:flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group rounded-xl overflow-hidden bg-background-50 hover:bg-background-200/50 transition-colors"
            >
              <div className="aspect-[16/9] overflow-hidden">
                <img
                  src={article.cover}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 text-xs text-foreground-500 mb-3">
                  <span className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-700 font-medium">
                    {article.category}
                  </span>
                  <span>{article.date}</span>
                  <span><i className="ri-time-line mr-1"></i>{article.readTime}</span>
                </div>
                <h3 className="text-base font-semibold text-foreground-900 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="mt-3 text-sm text-foreground-600 line-clamp-2 leading-relaxed">
                  {article.excerpt}
                </p>
              </div>
            </Link>
          ))}
        </div>

        <div className="flex sm:hidden justify-center mt-8">
          <Link
            to="/articles"
            className="flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            查看全部资讯 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}